import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import {useMuseumStore} from '@/roc/stores/MuseumStore';

class MuseumBonus extends CultureBonus
{
  constructor () {
    super(
      CultureAmount.asMuseum(),
      CultureRange.asFlat(0)
    );
  }

  getBonus() {
    const museumStore = useMuseumStore();

    return museumStore.cultureBonus;
  }

  clone() {
    return new MuseumBonus();
  }
}

export default MuseumBonus;
